import Phaser from 'phaser';

import Button from "./classes/Button.js";
import NamePanel from "./classes/NamePanel.js";
import Score from "./classes/Score.js";
import WinsContainer from "./classes/WinsContainer.js";
import PlayerBoard from "./classes/PlayerBoard.js";
import CardSlot from "./classes/CardSlot.js";
import Timer from "./classes/Timer.js";
import StatusMessage from "./classes/StatusMessage.js";
import PlayerStats from "./classes/PlayerStats.js";
import SpectatorCount from "./classes/spectatorCount.js"
import EmojiMenu from "./classes/EmojiMenu.js";
import CardGameObject, { Card } from "./classes/Card.js";
import dictionary from '../../../constants/cardsDictionary.json'
import  VfxSprite  from "./classes/VfxSprite.js";
import WinModal from './classes/WinModal.js';
import CoinFountain from './classes/CoinFountain.js';
import PotCounter from "./classes/PotCounter.js";
import  MouseChaser  from "./classes/MouseChaser.js";
import { createNewTween } from "./classes/TweenMaker.js";
import { user, client, session, socket, socketConnected } from "../../../utils/nakama";
import componentCoordinates from './componentCoordinates.js';
import { matchIdGame, gameData, emojiData, isSpectator, playerBonezMatchData, leaveGameSpectator } from "../Game.jsx";
import emojiDictionary from "../../../constants/emojiDictionary.json";
import opCodes from "../../../constants/opCodes.jsx";
import eventsCenter, { PHASER_EVENTS } from '../../../utils/phaserEvents';
 
let scale;
let screenWidth = window.outerWidth; // 3840 is for 16:9 ,  2532 (scaled to 3840) is for 19.5:9
let screenHeight = window.outerHeight; // 2160 is for 16:9 ,  1170 (scaled to 1774) is for 19.5:9

export let cardScale;
// export let scalelgm = {"scale": scale}; //leavegamemoddal.jsx
// export let leaveModalValue = {"value": false};
export let spectatorBoxCount = null;

export default class BonezGame extends Phaser.Scene {
    constructor() {
        super("BonezGame");
        this.previousGameData = null;
        this.previousEmojiData = null;
        this.previousOpponentBoard = null;
        this.previousPlayerBoard = null;
        // this.spectatorCount = null; //spectator component
        this.emojiMenu = null;

        this.playerWinsContainer = null;
        this.playerScore = null;
        this.playerBoard = null;
        this.opponentScore = null;
        this.opponentBoard = null;
        this.opponentWinsContainer = null;

        this.turnTimer = null;
        this.playerIsStanding = false;
        this.opponentIsStanding = false;
        this.opponentWins = 0;
        this.playerWins = 0;
        this.statusMessage = null;

        this.opponentCard1 = null;
        this.opponentCard2 = null;
        this.opponentCard3 = null;
        this.opponentCard4 = null;
        this.playerCard1 = null;
        this.playerCard2 = null;
        this.playerCard3 = null;
        this.playerCard4 = null;

        this.playerUserLevels = null;
        this.opponentUserLevels = null;
        this.lastSpectatorLength = 0;
    }

    preload() {
        this.load.image("msg_online", "/bonez/images/messages_approved.png");
        this.load.image("msg_online_pending", "/bonez/images/messages_pending.png");

        if (!isSpectator) { //player
            if (screenWidth >= 1200) { //desktop
                scale = componentCoordinates.desktop;
                cardScale = componentCoordinates.desktop.cardScale;
            }
            else {
                scale = componentCoordinates.mobile;
                cardScale = componentCoordinates.mobile.cardScale;
            }
        }
        else { //spectator
            if (screenWidth >= 1200) { //desktop
                scale = componentCoordinates.desktopSpectator;
                cardScale = componentCoordinates.desktopSpectator.cardScale;
            }
            else {
                scale = componentCoordinates.mobileSpectator;
                cardScale = componentCoordinates.mobileSpectator.cardScale;
            }
        }

        // console.log("PHASER: ", gameData);
        // console.log("NAKAMA: ", client);
        // console.log("user: ", user);
        socket.onmessage = (e) => {
             console.log("BonezGame Received server message: ", e);
        }
        // this.load.image("PandaPfp", "/bonez/images/panda_pfp.png");
        if (gameData && gameData.opponent.avatarUrl !== null && gameData.opponent.avatarUrl !== "") {
            this.load.image("pfpOpponent", gameData.opponent.avatarUrl);
        }
        else { //load default panda pfp
            this.load.image("pfpOpponent", "/bonez/images/panda_pfp.png");
        }
        
        if (gameData && gameData.player.avatarUrl !== null && gameData.player.avatarUrl !== "") {
            this.load.image("pfpPlayer", gameData.player.avatarUrl);
        }
        else {
            this.load.image("pfpPlayer", "/bonez/images/panda_pfp.png");
        }

    }
    create() {

        // fade in the scene
        this.cameras.main.fadeIn(500, 0, 0, 0);

        // declare sounds first
        this.snd_click = this.sound.add('snd_click');
        this.snd_draw_card = this.sound.add('snd_draw_card');
        this.snd_house_power = this.sound.add('snd_house_power');
        this.snd_nft_power = this.sound.add('snd_nft_power');
        this.snd_win = this.sound.add('snd_win');
        this.snd_damage = this.sound.add('snd_damage');
        this.snd_lose = this.sound.add('you_lose');
        this.snd_tie = this.sound.add('snd_tie');

        this.LOCAL_STORAGE_MUSIC_VOLUME = 'musicVolume';
        this.LOCAL_STORAGE_SOUND_VOLUME = 'soundVolume';

        // fetching values from local storage or use default values
        this.musicVolumeFromStorage = localStorage.getItem(this.LOCAL_STORAGE_MUSIC_VOLUME);
        this.soundVolumeFromStorage = localStorage.getItem(this.LOCAL_STORAGE_SOUND_VOLUME);

        this.musicVolume = this.musicVolumeFromStorage !== null ? +this.musicVolumeFromStorage / 100 : 12.5 / 100;
        this.soundVolume = this.soundVolumeFromStorage !== null ? +this.soundVolumeFromStorage / 100 : 12.5 / 100;

        this.checkForVolumeChange = () => {
            let newMusicVolume = localStorage.getItem(this.LOCAL_STORAGE_MUSIC_VOLUME);
            let newSoundVolume = localStorage.getItem(this.LOCAL_STORAGE_SOUND_VOLUME);

            newMusicVolume = newMusicVolume !== null ? +newMusicVolume / 100 : 12.5 / 100;
            newSoundVolume = newSoundVolume !== null ? +newSoundVolume / 100 : 12.5 / 100;

            if (this.musicVolume !== newMusicVolume) {
                this.musicVolume = newMusicVolume;

                // this.snd_win.setVolume(this.soundVolume); 
                // this.snd_damage.setVolume(this.soundVolume);
                // this.snd_lose.setVolume(this.soundVolume);
            }

            if (this.soundVolume !== newSoundVolume) {
                this.soundVolume = newSoundVolume;

                this.snd_click.setVolume(this.soundVolume);
                this.snd_draw_card.setVolume(this.soundVolume);
                this.snd_house_power.setVolume(this.soundVolume);
                this.snd_nft_power.setVolume(this.soundVolume);
                this.snd_win.setVolume(this.soundVolume); 
                this.snd_damage.setVolume(this.soundVolume);
                this.snd_lose.setVolume(this.soundVolume);
                this.snd_tie.setVolume(this.soundVolume);
            }
        }

        this.playRandomVfxInBg = () => {
            new VfxSprite(this, Phaser.Math.FloatBetween(10, this.scale.width), Phaser.Math.FloatBetween(10, this.scale.height), 'blue_light_burst', 0, {
                direction: Phaser.Math.FloatBetween(-0.2, 0.2),
                scale: Phaser.Math.FloatBetween(0.01, 0.2),
                frames: 64,
                delay: Phaser.Math.FloatBetween(0, 1000),
            }).setDepth(-1);
        }
        
//TODO Replace this with an event listener, for Event emitted from react, OnVolumeChange
        this.time.addEvent({
            delay: 500,
            callback: this.checkForVolumeChange,
            loop: true
        });

        this.time.addEvent({
            delay: 1000,
            callback: this.playRandomVfxInBg,
            loop: true
        });
//TODO Replace this with an event listener, for Event emitted from react, OnVolumeChange

        if (!isSpectator) {
            this.standButton = this.add.button(scale.standButton.x, scale.standButton.y, "PurpleButton", scale.standButton.scale, "STAND", scale.standButton.fontSize, async () => {
                this.snd_click.play();
                this.snd_click.setVolume(this.soundVolume);
                this.standButton.setButtonVisibility(false);
                this.endTurnButton.setButtonVisibility(false);
                //this.setStealSelected(false);
                if (socketConnected && matchIdGame !== "") {
                    try {
                        await socket.sendMatchState(matchIdGame, opCodes.playerStand, null);
                        //console.log("Stand requested");
                    } catch (err) {
                        console.error("Server error call standing: ", err);
                    }
                }
            });

            this.standButton.setDepth(10000);
        }

        if (!isSpectator) {
            this.endTurnButton = this.add.button(scale.endTurnButton.x, scale.endTurnButton.y, "GreenButton", scale.endTurnButton.scale, "END TURN", scale.endTurnButton.fontSize, async () => {
                this.snd_click.play();
                this.snd_click.setVolume(this.soundVolume);
                this.endTurnButton.setButtonVisibility(false);
                this.standButton.setButtonVisibility(false);
                //this.setStealSelected(false);
                if (socketConnected && matchIdGame !== "") {
                    try {
                        await socket.sendMatchState(matchIdGame, opCodes.playerEndTurn, null);
                        // console.log("End turn requested");
                    } catch (err) {
                        console.error("Error ending turn: ", err);
                    }
                }
            });

            this.endTurnButton.setDepth(10000);
        }

        if (this.turnTimer === null) {
            this.turnTimer = this.add.timer(scale.turnTimer.x, scale.turnTimer.y, scale.turnTimer.scale, scale.turnTimer.fontSize, 100);
            // if(this.tweenTurnTimer == null){
            //     createNewTween(this, this.turnTimer);
            // }
        }

        if (this.statusMessage === null) {
            this.statusMessage = this.add.statusMessage(scale.statusMessage.x, scale.statusMessage.y, scale.statusMessage.scale);
            this.children.bringToTop(this.statusMessage);
            this.statusMessage.setDepth(10);
        }

        //opponent
        this.opponentNamepanel = this.add.namePanel(scale.opponent.namePanel.x, scale.opponent.namePanel.y, scale.opponent.namePanel.scale, "pfpOpponent", gameData.opponent, false, false); //bool is for VIP status
        this.opponentNamepanel.setInteractive();
        this.opponentNamepanel.on('pointerdown', function(pointer) {
            window.Phaser.MyInfo = false;
            window.Phaser.PlayerInfo = true;
            this.opponentNamepanel.setNotifyVisible(false);
        }, this);
        // this.add.text(scale.opponent.winsText.x, scale.opponent.winsText.y, "WINS", {fontFamily: "TruculentaBold", fontSize: scale.opponent.winsText.fontSize, color: "#B2F1FF", align: "center"}).setOrigin(0.5);
        this.opponentBoard = this.add.playerBoard(scale.opponent.playerBoard.x, scale.opponent.playerBoard.y, scale.opponent.playerBoard.scale, []);
        if (scale.player.playerStats) { //spectator component
            this.add.playerStats(scale.opponent.playerStats.x, scale.opponent.playerStats.y, scale.opponent.playerStats.scale, scale.opponent.playerStats.lineHeightScale, gameData.opponent.gamesPlayed, gameData.opponent.bonezWon, gameData.opponent.zoomWon, gameData.opponent.gamesLost);
        }
        //Add chat icon
        this.chatImage = this.add.image(scale.opponent.chatIcon.x, scale.opponent.chatIcon.y, "msg_online").setScale(scale.opponent.chatIcon.scale).setDepth(5);
        this.chatImage.setInteractive();
        this.chatImage.on('pointerdown', function(pointer) {
            //console.log("Chat icon clicked");
            window.Phaser.showPlayerChat = true;
            this.chatImage.setTexture("msg_online");
        }, this);

        eventsCenter.on(PHASER_EVENTS.CHAT_NOTIFICATION, (notification) => {
            //console.log("Chat notification received: ", notification);
            this.chatImage.setTexture("msg_online_pending");
        });
            
        //player
        this.playerNamepanel = this.add.namePanel(scale.player.namePanel.x, scale.player.namePanel.y, scale.player.namePanel.scale, "pfpPlayer", gameData.player, false, true);
        this.playerNamepanel.setInteractive();
        this.playerNamepanel.on('pointerdown', function(pointer) {
            window.Phaser.PlayerInfo = false;
            window.Phaser.MyInfo = true;
            this.playerNamepanel.setNotifyVisible(false);
        }, this);

        // this.add.text(scale.player.winsText.x, scale.player.winsText.y, "WINS", {fontFamily: "TruculentaBold", fontSize: scale.player.winsText.fontSize, color: "#B2F1FF", align: "center"}).setOrigin(0.5);
        this.playerBoard = this.add.playerBoard(scale.player.playerBoard.x, scale.player.playerBoard.y, scale.player.playerBoard.scale, []); 
        if (scale.opponent.playerStats) { //spectator component
            this.add.playerStats(scale.player.playerStats.x, scale.player.playerStats.y, scale.player.playerStats.scale, scale.player.playerStats.lineHeightScale, gameData.player.gamesPlayed, gameData.player.bonezWon, gameData.player.zoomWon, gameData.player.gamesLost);
        }
        // if (scale.playerStatsBackground) { //spectator component
        //     this.add.image(scale.playerStatsBackground.x, scale.playerStatsBackground.y, "PlayerStatsBackground").setScale(scale.playerStatsBackground.scaleX, scale.playerStatsBackground.scaleY).setDepth(-1);
        // }

        //emojis
        if (scale.emojiMenu) {
            this.emojiMenu = this.add.emojiMenu(scale.emojiMenu.x, scale.emojiMenu.y, scale.emojiMenu.scale, emojiDictionary, gameData.spectatorsEmojis);
            this.emojiMenu.setInteractive();
            if (!isSpectator) {
                this.emojiMenu.setButtonVisibility(!gameData.isPlayerTurn);
            }
        }

        //VFX Test
        // this.pinkBall = new VfxSprite(this, Math.random() * 1000, Math.random() * 600 + 10, 'vfx-pink-ball');
        // this.blueTornado = new VfxSprite(this, Math.random() * 1000, Math.random() * 600, 'vfx-blue', 10);
        // this.blueTornado.on('animationcomplete', function () {
        //     this.blueTornado.destroy();
        // }, this);
        // this.redTornado = new VfxSprite(this, Math.random() * 1000, Math.random() * 600, 'vfx-red-tornado', -1);
        // this.aquaBall2 = new VfxSprite(this, Math.random() * 1000, Math.random() * 600, 'vfx-aqua-ball2', -1);
        // this.yellowball3 = new VfxSprite(this, Math.random() * 1000, Math.random() * 800, 'vfx-yellow-ball3', -1);
        // this.greenBall4 = new VfxSprite(this, Math.random() * 1000, Math.random() * 800, 'vfx-green-ball4', -1);
        // this.greenGate = new VfxSprite(this, Math.random() * 1000, Math.random() * 800, 'vfx-green-gate', -1);
        
        // Event listener for spawning VFX
        this.MouseChaser = new MouseChaser(this, 100, 100);
        this.MouseChaser.alpha = 0;
        this.MouseChaser.active = false; //don't update()
    }

    update() {
        //check if gameData is updated
        if (this.previousGameData !== gameData) {
            // console.log("gameData updated: ", gameData);
            if (!gameData) {
                console.log("gameData is null");
                return;
            }

            // Creating and hiding onfire
            if(gameData.player.consecutiveWins >= 2){
                this.playerNamepanel.showOnfire();
            }else{
                this.playerNamepanel.hideOnfire();
            }

            if(gameData.opponent.consecutiveWins >= 2){
                this.opponentNamepanel.showOnfire();
            }else{
                this.opponentNamepanel.hideOnfire();
            }

            //timer update
            if (gameData.turnTimer !== this.turnTimer.getTime()) {
                this.turnTimer.updateTime(gameData.turnTimer);
                if(this.tweenTurnTimer == null) {
                    //console.log("creating new tween");
                    createNewTween(this, this.turnTimer); //THIS DOESN'T WORK YET :(
                }
            }

            //new card sound
            if (this.previousGameData ) {
                if ((gameData.playerCardsOnField.length > this.previousGameData.playerCardsOnField.length || gameData.opponentCardsOnField.length > this.previousGameData.opponentCardsOnField.length)) {
                    this.snd_draw_card.play();
                    this.snd_draw_card.setVolume(this.soundVolume);

                    var playerCardLength = gameData.playerCardsOnField.length;
                    var opponentCardLength = gameData.opponentCardsOnField.length;
                    //Checking if player's normal card is drawn
                    if(gameData.isPlayerTurn === true && gameData.playerPowerCards.length === this.previousGameData.playerPowerCards.length){
                        new VfxSprite(this, 454.58 + 276.88 * playerCardLength, 1389.08, 'shockwave', 0, {
                                direction: 0,
                                scale: 1.5,
                                frames: 16,                                
                        });
                    }
                    //Checking if opponent's normal card is drawn
                    if(gameData.isPlayerTurn === false && gameData.opponentPowerCards === this.previousGameData.opponentPowerCards){
                        new VfxSprite(this, 454.58 + 276.88 * opponentCardLength, 545.8, 'shockwave', 0, {
                            direction: 0,
                            scale: 1.5,
                            frames: 16,                            
                        });
                    }
                }
            }

            //play power sounds and vfx effect
            // detect incoming power card payload and compare dictionary if card is in housePowerCards/nftPowerCards arrays
            if (this.previousGameData){
                if (gameData.opponentPowerCards < this.previousGameData.opponentPowerCards) { //Checking if a power card has been played

                    var n = this.previousGameData.opponentCardsOnField.length;
                    var playedCard = gameData.opponentCardsOnField[n];
                    const [prevOpponentCard] = this.opponentBoard.playedCards[n-1];
                    if (playedCard){ //some power cards used aren't going to be on field 
                        if (dictionary.housePowerCards[playedCard[0].name] !== undefined) {
                            this.snd_house_power.play();
                            this.cameras.main.shake(100);
                            this.snd_house_power.setVolume(this.soundVolume);
                            new VfxSprite(this, prevOpponentCard.x + 265, prevOpponentCard.y, 'shockwave', 0, {
                                direction: 0,
                                scale: 4,
                                frames: 16,                                
                            });
                            let white_splash1 = new VfxSprite(this, prevOpponentCard.x + 500, prevOpponentCard.y, 'white_splash', 0, {
                                direction: 0,
                                scale: 3,
                                frames: 16,                                
                            });
                            //Displaying white light on top left and top right of the board
                            let white_light_flash1 = new VfxSprite(this, 500, prevOpponentCard.y - 200, 'white_light_flash', 0, {
                                direction: 0,
                                scale: 1.5,
                                frames: 16,                         
                            });
                            let white_light_flash2 = new VfxSprite(this, 3200, prevOpponentCard.y - 200, 'white_light_flash', 0, {
                                direction: 0,
                                scale: 1.5,
                                frames: 16,
                            });
                            white_splash1.setDepth(100);
                            white_light_flash1.setDepth(100);
                            white_light_flash2.setDepth(100);
                        }
                        else if ((dictionary.nftPowerCards[playedCard[0].name] !== undefined) || playedCard[1]){
                            this.snd_nft_power.play();
                            this.cameras.main.shake(500);
                            this.snd_nft_power.setVolume(this.soundVolume);
                            let blue_light_burst = new VfxSprite(this, prevOpponentCard.x + 276.88, prevOpponentCard.y, 'blue_light_burst', 0, {
                                direction: 0,
                                scale: 1.5,
                                frames: 64,
                                delay: 200,
                            });
                            let firework1 = new VfxSprite(this, 1000, prevOpponentCard.y - 300, 'firework', 0, {
                                direction: 0,
                                scale: 4,
                                frames: 16,
                            });
                            let firework2 = new VfxSprite(this, 2700, prevOpponentCard.y - 300, 'firework', 0, {
                                direction: 0,
                                scale: 4,
                                frames: 16,
                            });
                            //Displaying white light on top left and top right of the board
                            let blue_light_flash1 = new VfxSprite(this, 500, prevOpponentCard.y - 200, 'blue_light_flash', 0, {
                                direction: 0,
                                scale: 3,
                                frames: 16,
                                delay: 200,
                            });
                            let blue_light_flash2 = new VfxSprite(this, 3200, prevOpponentCard.y - 200, 'blue_light_flash', 0, {
                                direction: 0,
                                scale: 3,
                                frames: 16,
                                delay: 400,
                            });
                            blue_light_burst.setDepth(100);
                            firework1.setDepth(100);
                            firework2.setDepth(100);
                            blue_light_flash1.setDepth(100);
                            blue_light_flash2.setDepth(100);
                        }
                    } else {
                        //Case where redraw is played which displays a card in the second row of the column already played in
                        playedCard = gameData.opponentCardsOnField[n-1];
                        if (playedCard && playedCard[1]) {
                            this.snd_nft_power.play();
                            this.cameras.main.shake(500);

                            this.snd_nft_power.setVolume(this.soundVolume);
                            let blue_light_burst = new VfxSprite(this, prevOpponentCard.x + 276.88, prevOpponentCard.y + 200, 'blue_light_burst', 0, {
                                direction: 0,
                                scale: 1.5,
                                frames: 64,
                                delay: 200,
                            });
                            let firework1 = new VfxSprite(this, 1000, prevOpponentCard.y - 300, 'firework', 0, {
                                direction: 0,
                                scale: 4,
                                frames: 16,
                            });
                            let firework2 = new VfxSprite(this, 2700, prevOpponentCard.y - 300, 'firework', 0, {
                                direction: 0,
                                scale: 4,
                                frames: 16,
                            });
                            //Displaying white light on top left and top right of the board
                            let blue_light_flash1 = new VfxSprite(this, 550, prevOpponentCard.y - 200, 'blue_light_flash', 0, {
                                direction: 0,
                                scale: 3,
                                frames: 16,
                                delay: 200,
                            });
                            let blue_light_flash2 = new VfxSprite(this, 3200, prevOpponentCard.y - 200, 'blue_light_flash', 0, {
                                direction: 0,
                                scale: 3,
                                frames: 16,
                                delay: 400,
                            });
                            blue_light_burst.setDepth(100);
                            firework1.setDepth(100);
                            firework2.setDepth(100);
                            blue_light_flash1.setDepth(100);
                            blue_light_flash2.setDepth(100);
                        }
                    }
                }
                if (gameData.playerPowerCards < this.previousGameData.playerPowerCards) {
                    var n = this.previousGameData.playerCardsOnField.length;
                    var playedCard = gameData.playerCardsOnField[n];
                    const [prevPlayerCard] = this.playerBoard.playedCards[n-1];
                    if (playedCard){ //some power cards used aren't going to be on field 
                        if (dictionary.housePowerCards[playedCard[0].name] !== undefined) {
                            this.snd_house_power.play();
                            this.cameras.main.shake(100);
                            this.snd_house_power.setVolume(this.soundVolume);
                            new VfxSprite(this, prevPlayerCard.x + 265, prevPlayerCard.y, 'shockwave', 0, {
                                direction: 0,
                                scale: 4,
                                frames: 16,
                            });
                            let white_splash1 = new VfxSprite(this, prevPlayerCard.x + 500, prevPlayerCard.y, 'white_splash', 0, {
                                direction: 0,
                                scale: 3,
                                frames: 16,
                            });
                            //Displaying white light on top left and top right of the board
                            let white_light_flash1 = new VfxSprite(this, 550, prevPlayerCard.y - 200, 'white_light_flash', 0, {
                                direction: 0,
                                scale: 1.5,
                                frames: 16,
                                delay: 200,
                            });
                            let white_light_flash2 = new VfxSprite(this, 3200, prevPlayerCard.y - 200, 'white_light_flash', 0, {
                                direction: 0,
                                scale: 1.5,
                                frames: 16,
                                delay: 400,
                            });
                            white_splash1.setDepth(100);
                            white_light_flash1.setDepth(100);
                            white_light_flash2.setDepth(100);
                        }
                        else if (dictionary.nftPowerCards[playedCard[0].name] !== undefined || playedCard[1]){
                            this.snd_nft_power.play();
                            this.cameras.main.shake(500);

                    
                            this.snd_nft_power.setVolume(this.soundVolume);
                            let blue_light_burst = new VfxSprite(this, prevPlayerCard.x + 276.88, prevPlayerCard.y, 'blue_light_burst', 0, {
                                direction: 0,
                                scale: 1.5,
                                frames: 64,
                                delay: 200,
                            });
                            let firework1 = new VfxSprite(this, 1000, prevPlayerCard.y - 300, 'firework', 0, {
                                direction: 0,
                                scale: 4,
                                frames: 16,
                            });
                            let firework2 = new VfxSprite(this, 2700, prevPlayerCard.y - 300, 'firework', 0, {
                                direction: 0,
                                scale: 4,
                                frames: 16,
                            });
                            //Displaying white light on top left and top right of the board
                            let blue_light_flash1 = new VfxSprite(this, 500, prevPlayerCard.y - 200, 'blue_light_flash', 0, {
                                direction: 0,
                                scale: 3,
                                frames: 16,
                                delay: 200,
                            });
                            let blue_light_flash2 = new VfxSprite(this, 3200, prevPlayerCard.y - 200, 'blue_light_flash', 0, {
                                direction: 0,
                                scale: 3,
                                frames: 16,
                                delay: 400,
                            });
                            blue_light_burst.setDepth(100);
                            firework1.setDepth(100);
                            firework2.setDepth(100);
                            blue_light_flash1.setDepth(100);
                            blue_light_flash2.setDepth(100);
                        }
                    } else {
                        //Case where redraw is played which displays a card in the second row of the column already played in
                        playedCard = gameData.playerCardsOnField[n-1];
                        if (playedCard && playedCard[1]) {
                            this.snd_nft_power.play();
                            this.cameras.main.shake(500);

                            this.snd_nft_power.setVolume(this.soundVolume);
                            let blue_light_burst = new VfxSprite(this, prevPlayerCard.x + 276.88, prevPlayerCard.y + 200, 'blue_light_burst', 0, {
                                direction: 0,
                                scale: 1.5,
                                frames: 64,
                                delay: 200,
                            });
                            let firework1 = new VfxSprite(this, 1000, prevPlayerCard.y - 300, 'firework', 0, {
                                direction: 0,
                                scale: 4,
                                frames: 16,
                            });
                            let firework2 = new VfxSprite(this, 2700, prevPlayerCard.y - 300, 'firework', 0, {
                                direction: 0,
                                scale: 4,
                                frames: 16,
                            });
                            //Displaying white light on top left and top right of the board
                            let blue_light_flash1 = new VfxSprite(this, 500, prevPlayerCard.y - 200, 'blue_light_flash', 0, {
                                direction: 0,
                                scale: 3,
                                frames: 16,
                                delay: 200,
                            });
                            let blue_light_flash2 = new VfxSprite(this, 3200, prevPlayerCard.y - 200, 'blue_light_flash', 0, {
                                direction: 0,
                                scale: 3,
                                frames: 16,
                                delay: 400,
                            });
                            blue_light_burst.setDepth(100);
                            firework1.setDepth(100);
                            firework2.setDepth(100);
                            blue_light_flash1.setDepth(100);
                            blue_light_flash2.setDepth(100);
                        }
                    }

                }
            }

            //emojis
            if (this.emojiMenu && gameData.opponent.sentEmojis) {
                this.emojiMenu.displayReceivedEmoji(gameData.opponent.sentEmojis, "opponent");
            }
            if (this.emojiMenu && gameData.player.sentEmojis) {
                this.emojiMenu.displayReceivedEmoji(gameData.player.sentEmojis, "player");
            }
            if (this.emojiMenu && gameData.spectatorsEmojis) {
                this.emojiMenu.displayReceivedEmojiSpectator(gameData.spectatorsEmojis, gameData.matchInfo.spectators); // Spectator
            }
            
            //update player standing memory IF knocked back into play by steal card
            if (this.isPlayerStanding && !gameData.isPlayerStanding) {
                this.isPlayerStanding = false;
            }
            if (this.isOpponentStanding && !gameData.isOpponentStanding) {
                this.isOpponentStanding = false;
            }

            //update buttons
            if (gameData.isPlayerTurn && !isSpectator) {
                this.standButton.setInteractive();
                this.endTurnButton.setInteractive();
                
                //Only enable standButton if more than 1 card on table && oppoent score is less than ours
                if(gameData.playerCardsOnField.length > 1 && gameData.opponentScore <= gameData.playerScore){
                    this.standButton.setButtonVisibility(true);
                }
                this.endTurnButton.setButtonVisibility(true);
                this.emojiMenu.setButtonVisibility(false); //can not send emojis when it's your turn
                this.emojiMenu.disableInteractive();
            } else if (!gameData.isPlayerTurn && !isSpectator) {
                this.standButton.disableInteractive();
                this.endTurnButton.disableInteractive();
                this.standButton.setButtonVisibility(false);
                this.endTurnButton.setButtonVisibility(false);
                this.emojiMenu.setButtonVisibility(true);
                this.emojiMenu.setInteractive();
            }

            //status update
            this.MouseChaser.disableChaser();
            if (gameData.playerCardsOnField.length === 0 && gameData.opponentCardsOnField.length === 0) {
                // waiting game status
                this.statusMessage.displayWaitingMatchStart(client, session, gameData);
            }
            else if (gameData.playerWins !== this.playerWins && this.previousGameData) { //do not play sound on first render (previousGameData is null)
                this.statusMessage.displayRoundWin(gameData.player.username.toString());
                //Show skull animation
                const tempSkull = this.add.image(scale.player.namePanel.x, scale.player.namePanel.y, 'all_images', 'win_marker').setScale(2).setDepth(100);
                this.tweens.add({
                    targets: tempSkull,
                    x : this.playerWinsContainer.x,
                    y : this.playerWinsContainer.y,
                    rotation: 360,
                    scale: 1,
                    alpha: 1,
                    duration: 500,
                    ease: 'Linear',
                    repeat: 0,
                    yoyo: false,
                    onComplete: () => {
                        tempSkull.destroy();
                    }
                });            
                if (!isSpectator) {
                    //Disable the sound when the gameData.playerWins is 3
                    if (gameData.playerWins !== 3) { 
                        this.snd_win.play();
                        this.snd_win.setVolume(this.soundVolume);
                    }
                    //Match win as a player (X spectator)
                    else{  
                    //Update the value of winstreak
                    let winstreak = playerBonezMatchData.winStreak;
                    winstreak = winstreak + 1;

                    // Show winmodal
                    const winModal = new WinModal(this, scale.winModal.x, scale.winModal.y, scale.winModal.scale, winstreak, "pfpPlayer", gameData, playerBonezMatchData);
                    winModal.setDepth(100);

                    // To trigger the coin fountain:
                    new CoinFountain(this, scale.winModal.x , scale.winModal.y, scale.winModal.scale, gameData);

                    //Trigger pot counter
                    let potCounter = new PotCounter(this, scale.winModal.x, scale.winModal.y, scale.winModal.scale, gameData).setDepth(101);
                    potCounter.startCounting();
                    }

                    this.MouseChaser.enableChaser();
                    this.standButton.disableInteractive();
                    this.endTurnButton.disableInteractive();
                    this.standButton.setButtonVisibility(false);
                    this.endTurnButton.setButtonVisibility(false);
                    this.emojiMenu.setButtonVisibility(true);
                    this.emojiMenu.setInteractive();
                }
                else if (gameData.playerWins !== 3) { //spectator
                    this.snd_damage.play();
                    this.snd_damage.setVolume(this.soundVolume);
                }
                else { //match over as spectator
                    this.snd_win.play();
                    this.snd_win.setVolume(this.soundVolume);
                }
            }
            else if (gameData.opponentWins !== this.opponentWins && this.previousGameData) {
                this.statusMessage.displayRoundWin(gameData.opponent.username.toString());
                //Show skull animation
                const tempSkull = this.add.image(scale.opponent.namePanel.x, scale.opponent.namePanel.y, 'all_images', 'win_marker').setScale(2).setDepth(100);
                this.tweens.add({
                    targets: tempSkull,
                    x : this.opponentWinsContainer.x,
                    y : this.opponentWinsContainer.y,
                    rotation: 360,
                    scale: 1,   
                    alpha: 1,
                    duration: 500,
                    ease: 'Linear',
                    repeat: 0,
                    yoyo: false,
                    onComplete: () => {
                        tempSkull.destroy();
                    }
                });
                if (!isSpectator) {
                    if (gameData.opponentWins !== 3) {
                        this.snd_damage.play();
                        this.snd_damage.setVolume(this.soundVolume);
                    }
                    //Match lose as a player (X spectator)
                    else{
                        this.snd_damage.play();
                        this.snd_damage.setVolume(this.soundVolume);

                        this.snd_lose.play();
                        this.snd_lose.setVolume(this.soundVolume);
                    }

                    //disable buttons if this is a player
                    this.standButton.disableInteractive();
                    this.endTurnButton.disableInteractive();
                    this.standButton.setButtonVisibility(false);
                    this.endTurnButton.setButtonVisibility(false);
                    this.emojiMenu.setButtonVisibility(true);
                    this.emojiMenu.setInteractive();
                }
                else { //match over as spectator (opponent has 3 wins)
                    this.snd_win.play();
                    this.snd_win.setVolume(this.soundVolume);
                }
            }
            else if (gameData.isPlayerStanding && (gameData.isPlayerTurn || !this.isPlayerStanding)) {
                this.statusMessage.displayPlayerStand(gameData.player.username.toString());
                this.isPlayerStanding = true;
            }
            else if (gameData.isPlayerTurn) { //THE ORDER OF THIS BLOCK MATTERS!
                this.statusMessage.displayPlayerTurn(gameData.player.username.toString());
            }
            else if (gameData.isOpponentStanding && (!gameData.isPlayerTurn || !this.isOpponentStanding)) {
                this.statusMessage.displayPlayerStand(gameData.opponent.username.toString());
                this.isOpponentStanding = true;
            }
            else if (!gameData.isPlayerTurn) {
                this.statusMessage.displayPlayerTurn(gameData.opponent.username.toString());
            }
            
            //Round win update 
            if (gameData.playerWins !== this.playerWins) {
                this.playerWins = gameData.playerWins;
            }
            if (gameData.opponentWins !== this.opponentWins) {
                this.opponentWins = gameData.opponentWins;
            }

            //update spectator count
            if (scale.spectatorCount && !spectatorBoxCount && gameData.matchInfo.spectators.length > 0) {
                spectatorBoxCount = this.add.spectatorCount(scale.spectatorCount.x, scale.spectatorCount.y, scale.spectatorCount.scale, gameData.matchInfo.spectators, isSpectator);
                this.lastSpectatorLength = gameData.matchInfo.spectators.length;
            }
            if (gameData.matchInfo.spectators.length === 0 && spectatorBoxCount) {
                spectatorBoxCount.clearAvatars(); // Clear avatars before destroying the box count
                spectatorBoxCount.updateVisibility(false);
                spectatorBoxCount.destroy();
                spectatorBoxCount = null;
            } else if (scale.spectatorCount && spectatorBoxCount && gameData.matchInfo.spectators.length !== this.lastSpectatorLength) {
                this.lastSpectatorLength = gameData.matchInfo.spectators.length;
                spectatorBoxCount.clearAvatars(); // Clear avatars before destroying the box count
                spectatorBoxCount.updateVisibility(false);
                spectatorBoxCount.destroy();
                spectatorBoxCount = null;

                spectatorBoxCount = this.add.spectatorCount(scale.spectatorCount.x, scale.spectatorCount.y, scale.spectatorCount.scale, gameData.matchInfo.spectators, isSpectator);
                // Update spectatorBoxCount instead of destroying and recreating it
                spectatorBoxCount.updateSpectators(gameData.matchInfo.spectators);;
            }


            //opponent updates
            let opponentFieldCards = [];
            for (let i=0 ; i<gameData.opponentCardsOnField.length; i++) {  //convert gameData cards on field to Card objects
                if (gameData.opponentCardsOnField[i][0] && gameData.opponentCardsOnField[i][0].name) {
                    const firstCardName = gameData.opponentCardsOnField[i][0].name; //STRING
                    const firstCardValue = gameData.opponentCardsOnField[i][0].value; //INTEGER
                    const firstCardIsResurrected = gameData.opponentCardsOnField[i][0].isResurrected; //BOOLEAN
                    let newCard;
                    if (firstCardName === "1_or_11" && firstCardValue === 1) {
                        newCard = new Card(firstCardName, cardScale, "one_icon", firstCardIsResurrected, false);
                    }
                    else if (firstCardName === "1_or_11" && firstCardValue === 11) {
                        newCard = new Card(firstCardName, cardScale, "eleven_icon", firstCardIsResurrected, false);
                    }
                    else if ((firstCardName.slice(0, 8) === "plus_neg" || firstCardName === "tie_breaker") && firstCardValue > 0) {
                        newCard = new Card(firstCardName, cardScale, "plus_icon", firstCardIsResurrected, false);
                    }
                    else if ((firstCardName.slice(0, 8) === "plus_neg" || firstCardName === "tie_breaker") && firstCardValue < 0) {
                        newCard = new Card(firstCardName, cardScale, "minus_icon", firstCardIsResurrected, false);
                    }
                    else if (gameData.opponentCardsOnField[i][1] && gameData.opponentCardsOnField[i][1].name === "double") { //double card is present. Add the "x2" bubble
                        newCard = new Card(firstCardName, cardScale, "x2_icon", firstCardIsResurrected, false);
                    }
                    else if (Number.isInteger(parseInt(firstCardName)) && (parseInt(firstCardName) * 2 === firstCardValue)) { //stolen doubled card
                        newCard = new Card(firstCardName, cardScale, "x2_icon", firstCardIsResurrected, false);
                    }
                    else if (i === (gameData.opponentCardsOnField.length-1) && gameData.opponentCardsOnField && this.previousGameData && this.previousGameData.opponentCardsOnField && (gameData.opponentCardsOnField.length > this.previousGameData.opponentCardsOnField.length)) { //no bubble
                        if (this.previousGameData.playerCardsOnField && (gameData.playerCardsOnField.length < this.previousGameData.playerCardsOnField.length)){
                            //Case where a card has been stolen so the opposing player will have less cards than their previous render
                            for (var card in gameData.playerCardsOnField) {
                                 //Case where a card has been stolen so the opposing player will have less cards than their previous render
                                var startX; //used to tween card from spot on the opponent board
                                var startY;
                                for (var card in this.previousGameData.playerCardsOnField) {
                                    
                                    if (gameData.playerCardsOnField[card] !== this.previousGameData.playerCardsOnField[card]){

                                        startX = this.previousPlayerBoard[card].x;
                                        startY = this.previousPlayerBoard[card].y;

                                    }
                                }
                            }
                            newCard = new Card(firstCardName, cardScale, null, firstCardIsResurrected, true, startX, startY);
                        }
                        else {
                            newCard = new Card(firstCardName, cardScale, null, firstCardIsResurrected, true);
                        }
                    }
                    else {
                        newCard = new Card(firstCardName, cardScale, null, firstCardIsResurrected, false);
                    }

                    //SECOND CARD
                    if (gameData.opponentCardsOnField[i][1]) { //second card in the same column is present
                        opponentFieldCards.push([newCard, new Card(gameData.opponentCardsOnField[i][1].name, cardScale, null, gameData.opponentCardsOnField[i][1].isResurrected), false]);
                    }
                    else { //second card not present. Only push the first card
                        opponentFieldCards.push([newCard]);
                    }
                }
            }
            this.opponentBoard.updatePlayedCards(opponentFieldCards);
            this.opponentBoard.setStandBorder(gameData.isOpponentStanding);
            this.opponentBoard.setTurnBorder(!gameData.isPlayerTurn);

            //wins container
            if (this.opponentWinsContainer === null) {
                this.opponentWinsContainer = this.add.winsContainer(scale.opponent.winsContainer.x, scale.opponent.winsContainer.y, scale.opponent.winsContainer.scale, gameData.opponentWins);
            }
            else {
                this.opponentWinsContainer.updateWins(gameData.opponentWins);
            }
            
            //score
            if (this.opponentScore === null){
                this.opponentScore = this.add.score(scale.opponent.score.x, scale.opponent.score.y, scale.opponent.score.scale, 0, gameData.opponentScore, !gameData.isPlayerTurn); //last 2 params: score and isTurn (display "ScoreGreen" is true, "ScoreRed" if false)
                this.opponentScore.updateTurn(!gameData.isPlayerTurn, gameData.isOpponentStanding);
            }
            else {            
                this.opponentScore.updateScore(gameData.opponentScore)
                this.opponentScore.updateTurn(!gameData.isPlayerTurn, gameData.isOpponentStanding); //changing scoreboard colour
            }

            //OPPONENT POWER CARDS (hidden)
            let cardBackObject = new Card("back", scale.opponent.cardSlot1.scale, null);
            let count = gameData.opponentPowerCards;
            if (this.opponentCard1 === null) {
                this.opponentCard1 = this.add.cardSlot(scale.opponent.cardSlot1.x, scale.opponent.cardSlot1.y * 0.97, scale.opponent.cardSlot1.scale, (--count < 0) ? null : cardBackObject, 0, scale.opponent.cardSlot1.rotation);
            }
            else {
                this.opponentCard1.updateSlot((--count < 0) ? null : cardBackObject, 0);
            }

            if (this.opponentCard2 === null) {
                this.opponentCard2 = this.add.cardSlot(scale.opponent.cardSlot2.x, scale.opponent.cardSlot2.y * 0.97, scale.opponent.cardSlot2.scale, (--count < 0) ? null : cardBackObject, 1, scale.opponent.cardSlot2.rotation); 
            }
            else {
                this.opponentCard2.updateSlot((--count < 0) ? null : cardBackObject, 1);
            }

            if (this.opponentCard3 === null) {
                this.opponentCard3 = this.add.cardSlot(scale.opponent.cardSlot3.x, scale.opponent.cardSlot3.y * 0.97, scale.opponent.cardSlot3.scale, (--count < 0) ? null : cardBackObject, 2, scale.opponent.cardSlot3.rotation);
            }
            else {
                this.opponentCard3.updateSlot((--count < 0) ? null : cardBackObject, 2);
            }

            if (this.opponentCard4 === null) {
                this.opponentCard4 = this.add.cardSlot(scale.opponent.cardSlot4.x, scale.opponent.cardSlot4.y * 0.97, scale.opponent.cardSlot4.scale, (--count < 0) ? null : cardBackObject, 3, scale.opponent.cardSlot4.rotation);
            }
            else {
                this.opponentCard4.updateSlot((--count < 0) ? null : cardBackObject, 3);
            }

            //player updates
            let playerFieldCards = [];
            for (var i=0 ; i<gameData.playerCardsOnField.length; i++) { //convert gameData cards on field to Card objects
                if (gameData.playerCardsOnField[i][0] && gameData.playerCardsOnField[i][0].name) {
                    const firstCardName = gameData.playerCardsOnField[i][0].name; //STRING
                    const firstCardValue = gameData.playerCardsOnField[i][0].value; //INTEGER
                    const firstCardIsResurrected = gameData.playerCardsOnField[i][0].isResurrected; //BOOLEAN
                    let newCard;
                    if (firstCardName === "1_or_11" && firstCardValue === 1) {
                        newCard = new Card(gameData.playerCardsOnField[i][0].name, cardScale, "one_icon", firstCardIsResurrected, false);
                    }
                    else if (firstCardName === "1_or_11" && firstCardValue === 11) {
                        newCard = new Card(gameData.playerCardsOnField[i][0].name, cardScale, "eleven_icon", firstCardIsResurrected, false);
                    }
                    else if ((firstCardName.slice(0, 8) === "plus_neg" || firstCardName === "tie_breaker") && firstCardValue > 0) {
                        newCard = new Card(gameData.playerCardsOnField[i][0].name, cardScale, "plus_icon", firstCardIsResurrected, false);
                    }
                    else if ((firstCardName.slice(0, 8) === "plus_neg" || firstCardName === "tie_breaker") && firstCardValue < 0) {
                        newCard = new Card(gameData.playerCardsOnField[i][0].name, cardScale, "minus_icon", firstCardIsResurrected, false);
                    }
                    else if (gameData.playerCardsOnField[i][1] && gameData.playerCardsOnField[i][1].name === "double") { //double card is present. Add the "x2" bubble
                        newCard = new Card(gameData.playerCardsOnField[i][0].name, cardScale, "x2_icon", firstCardIsResurrected, false);
                    }
                    else if (Number.isInteger(parseInt(firstCardName)) && (parseInt(firstCardName) * 2 === firstCardValue)) { //stolen doubled card
                        newCard = new Card(gameData.playerCardsOnField[i][0].name, cardScale, "x2_icon", firstCardIsResurrected, false);
                    }
                    else if (firstCardName.slice(0, 4) === "plus" || firstCardName.slice(0, 3) === "neg") {
                        newCard = new Card(gameData.playerCardsOnField[i][0].name, cardScale, null, firstCardIsResurrected, false);
                    }
                    else if  (i === (gameData.playerCardsOnField.length-1) && gameData.playerCardsOnField && this.previousGameData && this.previousGameData.playerCardsOnField && (gameData.playerCardsOnField.length > this.previousGameData.playerCardsOnField.length)) { //no bubble
                        if (this.previousGameData.opponentCardsOnField && (gameData.opponentCardsOnField.length < this.previousGameData.opponentCardsOnField.length)){
                            //Case where a card has been stolen so the opposing player will have less cards than their previous render
                            var startX; //used to tween card from spot on the opponent board
                            var startY;
                            for (var card in this.previousGameData.opponentCardsOnField) {
                                
                                if (gameData.opponentCardsOnField[card] !== this.previousGameData.opponentCardsOnField[card]){

                                    startX = this.previousOpponentBoard[card].x;
                                    startY = this.previousOpponentBoard[card].y;

                                }
                            }
                            newCard = new Card(firstCardName, cardScale, null, firstCardIsResurrected, true, startX, startY);
                        } else {        
                            newCard = new Card(firstCardName, cardScale, null, firstCardIsResurrected, true);
                        }
                    }
                    else { //no bubble
                        newCard = new Card(gameData.playerCardsOnField[i][0].name, cardScale, null, firstCardIsResurrected, false);
                    }

                    if (gameData.playerCardsOnField[i][1]) { //second card in the same column is present
                        playerFieldCards.push([newCard, new Card(gameData.playerCardsOnField[i][1].name, cardScale, null, gameData.playerCardsOnField[i][1].isResurrected), false]);
                    }
                    else { //second card not present. Only push the first card
                        playerFieldCards.push([newCard]);
                    }
                }
            }
            this.playerBoard.updatePlayedCards(playerFieldCards);
            this.playerBoard.setStandBorder(gameData.isPlayerStanding);
            this.playerBoard.setTurnBorder(gameData.isPlayerTurn);

            //wins container
            if (this.playerWinsContainer === null) {
                this.playerWinsContainer = this.add.winsContainer(scale.player.winsContainer.x, scale.player.winsContainer.y, scale.player.winsContainer.scale, gameData.playerWins);
            }
            else {
                this.playerWinsContainer.updateWins(gameData.playerWins);
            }

            //score
            if (this.playerScore === null){
                // console.log("creating new player score")
                this.playerScore = this.add.score(scale.player.score.x, scale.player.score.y, scale.player.score.scale, Math.PI, gameData.playerScore, gameData.isPlayerTurn);
                this.playerScore.updateTurn(gameData.isPlayerTurn, gameData.isPlayerStanding);
            } else {
                this.playerScore.updateScore(gameData.playerScore)
                this.playerScore.updateTurn(gameData.isPlayerTurn, gameData.isPlayerStanding);
            }
            
            //PLAYER POWER CARDS
            if (!isSpectator) {
                let playerPowerCards = [];
                for (let i = 0; i < gameData.playerPowerCards.length; i++) { //convert gameData power cards to Card objects
                    playerPowerCards.push(new Card(gameData.playerPowerCards[i], scale.player.cardSlot1.scale, null)); //bubble is added in cardSlot
                }

                if (this.playerCard1 === null) {
                    this.playerCard1 = this.add.cardSlot(scale.player.cardSlot1.x, scale.player.cardSlot1.y, scale.player.cardSlot1.scale, playerPowerCards[0], 0);
                }
                else {
                    this.playerCard1.updateSlot(playerPowerCards[0], 0);
                }

                if (this.playerCard2 === null) {
                    this.playerCard2 = this.add.cardSlot(scale.player.cardSlot2.x, scale.player.cardSlot2.y, scale.player.cardSlot2.scale, playerPowerCards[1], 1);
                }
                else {
                    this.playerCard2.updateSlot(playerPowerCards[1], 1);
                }

                if (this.playerCard3 === null) {
                    this.playerCard3 = this.add.cardSlot(scale.player.cardSlot3.x, scale.player.cardSlot3.y, scale.player.cardSlot3.scale, playerPowerCards[2], 2);
                }
                else {
                    this.playerCard3.updateSlot(playerPowerCards[2], 2);
                }

                if (this.playerCard4 === null) {
                    this.playerCard4 = this.add.cardSlot(scale.player.cardSlot4.x, scale.player.cardSlot4.y, scale.player.cardSlot4.scale, playerPowerCards[3], 3);
                }
                else {
                    this.playerCard4.updateSlot(playerPowerCards[3], 3);
                }
            }
            else { //spectator
                cardBackObject = new Card("back", scale.player.cardSlot1.scale, null);
                count = gameData.playerPowerCards;
                if (this.playerCard1 === null) {
                    this.playerCard1 = this.add.cardSlot(scale.player.cardSlot1.x, scale.player.cardSlot1.y, scale.player.cardSlot1.scale, (--count < 0) ? null : cardBackObject, 0);
                }
                else {
                    this.playerCard1.updateSlot((--count < 0) ? null : cardBackObject, 0);
                }
    
                if (this.playerCard2 === null) {
                    this.playerCard2 = this.add.cardSlot(scale.player.cardSlot2.x, scale.player.cardSlot2.y, scale.player.cardSlot2.scale, (--count < 0) ? null : cardBackObject, 1); 
                }
                else {
                    this.playerCard2.updateSlot((--count < 0) ? null : cardBackObject, 1);
                }
    
                if (this.playerCard3 === null) {
                    this.playerCard3 = this.add.cardSlot(scale.player.cardSlot3.x, scale.player.cardSlot3.y, scale.player.cardSlot3.scale, (--count < 0) ? null : cardBackObject, 2);
                }
                else {
                    this.playerCard3.updateSlot((--count < 0) ? null : cardBackObject, 2);
                }
    
                if (this.playerCard4 === null) {
                    this.playerCard4 = this.add.cardSlot(scale.player.cardSlot4.x, scale.player.cardSlot4.y, scale.player.cardSlot4.scale, (--count < 0) ? null : cardBackObject, 3);
                }
                else {
                    this.playerCard4.updateSlot((--count < 0) ? null : cardBackObject, 3);
                }
            }

            //allow cards to be dragged?
            if (!isSpectator) {
                this.playerCard1.updateInteractive(gameData.isPlayerTurn && gameData.playerCanPlayPowerCard);
                this.playerCard2.updateInteractive(gameData.isPlayerTurn && gameData.playerCanPlayPowerCard);
                this.playerCard3.updateInteractive(gameData.isPlayerTurn && gameData.playerCanPlayPowerCard);
                this.playerCard4.updateInteractive(gameData.isPlayerTurn && gameData.playerCanPlayPowerCard);
            }

            // console.log(this.previousScene && this.previousScene.opponentBoard);
            //     console.log(this.opponentBoard)
            if (!this.previousOpponentBoard || !this.previousPlayerboard || (this.previousOpponentBoard !== this.opponentBoard) || (this.previousPlayerBoard !== this.playerBoard)){
                // console.log(this.previousScene && this.previousScene.opponentBoard);
                // console.log(this.opponentBoard)
                this.previousOpponentBoard= []
                for (var card in this.opponentBoard.playedCards) {
                    this.previousOpponentBoard.push(this.opponentBoard.playedCards[card][0]);
                }
                this.previousPlayerBoard= []
                for (var card in this.playerBoard.playedCards) {
                    this.previousPlayerBoard.push(this.playerBoard.playedCards[card][0]);
                }
            }

            // //check if round is tied    
            if (gameData.isTie) {
                this.snd_tie.play();
                this.snd_tie.setVolume(this.soundVolume);
                // this.statusMessage.displayRoundTie(); -> React Modal used instead
                if (!isSpectator) {
                    this.standButton.disableInteractive();
                    this.endTurnButton.disableInteractive();
                    this.standButton.setButtonVisibility(false);
                    this.endTurnButton.setButtonVisibility(false);
                    this.emojiMenu.setButtonVisibility(true);
                    this.emojiMenu.setInteractive();
                }
            }

            this.previousGameData = gameData; //THIS LINE VERY IMPORTANT!
        }

        //check if only turn timer is updated
        else if (gameData && gameData.turnTimer !== this.turnTimer.getTime()) {
            // console.log("turn timer updated");
            //if (this.turnTimer >= 0) {
                this.turnTimer.updateTime(gameData.turnTimer);
            //}
        }

        //only emojis are updated
        else if (this.previousEmojiData !== emojiData) {
            // console.log("emojiData updated: ", emojiData);
            if (!emojiData) {
                return;
            }
            if (this.emojiMenu) {
                this.emojiMenu.displayReceivedEmoji(emojiData.playerSentEmojis, "player");
                this.emojiMenu.displayReceivedEmoji(emojiData.opponentSentEmojis, "opponent");
                if (gameData.spectatorsEmojis) {
                    this.emojiMenu.displayReceivedEmojiSpectator(emojiData.spectatorSentEmojis, gameData.matchInfo.spectators); // Spectator
                }
            }
            this.previousEmojiData = emojiData;
        }

        this.children.each(function(child) {
            if (child instanceof VfxSprite) {
                child.update();
            }
        });
    }
}